/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".divider-panel[_ngcontent-%COMP%]{clear:both;width:100%;height:1px}"];
export { styles as styles };
